import Benefits from './Benefits';
import type { EmailContentProps } from './EmailContent';

const GermanEmailContent = ({ requesterName, inviteeName, benefits }: EmailContentProps) => (
    <>
        Hallo{inviteeName !== '' ? ` ${inviteeName}` : ''},<br />
        <br />
        Sie haben eine neue Anfrage für eine Partnerverbindung{requesterName !== '' ? ` von "${requesterName}"` : ''}{' '}
        erhalten.
        <br />
        <br />
        Die Annahme der Partnerverbindung ermöglicht Ihnen:
        <Benefits benefits={benefits} />
        <button type='button' className='btn btn-default btn-link btn-xs'>
            Verbindungsanfrage einsehen
        </button>
        <br />
        <br />
        Um die Anfrage einsehen und annehmen zu können, benötigen Sie einen RIO-Account.
        <br />
        Haben Sie noch keinen?{' '}
        <button type='button' className='btn btn-default btn-link btn-xs'>
            Registrieren Sie sich jetzt kostenlos.
        </button>
    </>
);
export default GermanEmailContent;
